import React from 'react';
import moment from 'moment';

import PropTypes from 'prop-types';

import { DateFilterContainer } from './css';
import { Box, Text } from '../design/css';
import ManagedDatePicker from '../common/ManagedDatePicker';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';
import { useLocaleContext } from '../context/LocaleContext';
import { localeEn } from '../misc';

const DateFilter = ({ filterState, updateFilters }) => {
  const {
    ORDERS: {
      startDateLabel,
      endDateLabel,
      filterByOpenDate,
      filterBySubmissionDate
    }
  } = useLocalizedStringsContext();
  const locale = useLocaleContext();
  const copy = locale === localeEn ? 'en' : 'fr';
  const isDayAfterToday = day => day.isAfter(moment(), 'day');

  const {
    endDateOpenDate,
    endDateSubmissionDate,
    startDateOpenDate,
    startDateSubmissionDate
  } = filterState;
  // naki
  return (
    <DateFilterContainer onFocus={() => window.dispatchEvent(new Event('scroll'))}>
      <Box>
        <div style={{ marginBottom: '0.5rem' }}>
          <Text>{filterByOpenDate}</Text>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="filter-start-open"
              label={startDateLabel}
              disabled={!!(startDateSubmissionDate || endDateSubmissionDate)}
              value={startDateOpenDate || ''}
              onValueChange={v => updateFilters('startDateOpenDate', v)}
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              copy={copy}
            />
          </div>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="filter-end-open"
              label={endDateLabel}
              disabled={!!(startDateSubmissionDate || endDateSubmissionDate)}
              value={endDateOpenDate || ''}
              onValueChange={v => updateFilters('endDateOpenDate', v)}
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              copy={copy}
            />
          </div>
        </div>
      </Box>
      <Box>
        <div style={{ marginBottom: '0.5rem' }}>
          <Text>{filterBySubmissionDate}</Text>
        </div>
        <div style={{ display: 'flex', gap: '1rem' }}>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="filter-start-sub"
              label={startDateLabel}
              disabled={!!(startDateOpenDate || endDateOpenDate)}
              value={startDateSubmissionDate || ''}
              onValueChange={v => updateFilters('startDateSubmissionDate', v)}
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              copy={copy}
            />
          </div>
          <div style={{ flex: 1 }}>
            <ManagedDatePicker
              id="filter-end-sub"
              label={endDateLabel}
              disabled={!!(startDateOpenDate || endDateOpenDate)}
              value={endDateSubmissionDate || ''}
              onValueChange={v => updateFilters('endDateSubmissionDate', v)}
              isDayDisabled={isDayAfterToday}
              dateFormat="YYYY/MM/DD"
              initialVisibleMonth={moment().format('YYYY-MM-DD')}
              copy={copy}
            />
          </div>
        </div>
      </Box>
    </DateFilterContainer>
  );
};

DateFilter.propTypes = {
  filterState: PropTypes.shape({
    endDateOpenDate: PropTypes.string,
    endDateSubmissionDate: PropTypes.string,
    startDateOpenDate: PropTypes.string,
    startDateSubmissionDate: PropTypes.string
  }).isRequired,
  updateFilters: PropTypes.func.isRequired
};

export default DateFilter;
